<script>
   /*************************************************************/
   /* DatasetWidget                                             */
   /* -------------------------                                 */
   /* widget to show information about loaded dataset           */
   /*************************************************************/

   import { Container, ButtonCancel } from 'svelte-controls-basic';

   // dataset
   let { dataset, reset, title = '' } = $props();
</script>

{#if dataset }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="dataset-info">
         {#if title && title !== ''}<span style="font-weight:bold">{title}</span><br>{/if}
         <span>Data file:</span> <span title="{dataset.fileName}" class="file-name">{dataset.fileName}</span><br>
         <span>Size:</span>
         {#if dataset.nresp  && dataset.nresp > 0}
         <span class="file-size">{dataset.values.nrows}&times;{dataset.values.ncols - dataset.nresp}</span> <span>(X)</span>,
         <span class="file-size">{dataset.values.nrows}&times;{dataset.nresp}</span> <span>(Y)</span>
         {:else}
         <span class="file-size">{dataset.values.nrows}&times;{dataset.values.ncols}</span>
         {/if}
      </p>
      <ButtonCancel onclick={reset} />
   </Container>
{/if}

<style>

   .dataset-info {
      line-height: 1.5em;
   }
   .dataset-info > :global(span) {
      vertical-align: middle;
      color: #a0a0a0;
   }

   .dataset-info > .file-name,
   .dataset-info > .file-size {
      display: inline-block;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
      color: #222;
   }
</style>